<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="green"
          icon="shopping_cart"
          title="Total de Vendas"
          :value="salesTotal.toString()"
          small-value="#"
          sub-icon="house_siding"
          sub-text="Unidades Consumidoras Vendidas"
        />
      </v-flex>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="#095F96"
          icon="monetization_on"
          title="Comissões Recebidas"
          :value="salesPaid.toString()"
          small-value="#"
          sub-icon="attach_money"
          sub-text="Vendas Comissionadas"
        />
      </v-flex>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="red"
          icon="remove_shopping_cart"
          title="Vendas Desqualificadas"
          :value="salesDesqualify.toString()"
          small-value="#"
          sub-icon="money_off"
          :sub-text="
            salesDesqualifyDeb.toString() + ' desqualificados por débitos.'
          "
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("sales", [
      "salesTotal",
      "salesPaid",
      "salesDesqualify",
      "salesDesqualifyDeb",
    ]),
  },
  data: () => ({
    loading: false,
  }),
};
</script>
